import React, { useContext, useEffect, useState } from "react";
import WebServiceContext from "../WebService/ServiceContext";
import { BasicContext } from "../context/BasicContext";
import CardDetail from "./CardDetail";

import { SpinnerSvg, BookDot } from "./SVG"



//過濾條件用的temp物件
type TO = {
    [key: string]: string
}

type PDO = {
    [key: string]: string
}

//法遵用
type JHoursProp = {
    CourseHours: number | 0
}

export default (/*props:CardProps*/) => {
    const ws = useContext(WebServiceContext)
    const bc = useContext(BasicContext)

    //const [Cards, setCards] = useState<(CardProps)[]>([])
    const [nowCard, setNowCards] = useState<(CardProps)>()
    const [typeTitle, setTypeTitle] = useState<(string)>("")

    //分類相關20230628
    const [properties, setProperties] = useState<Properties[]>([])
    const [propertiesDictionary, setPropertiesDictionary] = useState<PDO>({})////以ID查詢分類的中文
    const [pCurrentCode, setPCurrentCode] = useState<string>("all")//現在取得的正確分類

    const getTimestamp = (timestamp: string) => {
        const match: string[] = timestamp.match(/Date\((\d+)\)/i) as string[]
        return parseInt(match[1])
    }


    const LessonDateFormat = (timestamp: string) => {
        const match: string[] = timestamp.match(/Date\((\d+)\)/i) as string[]

        if (match) {
            const _d = new Date(parseInt(match[1]))
            return `
                ${_d.getFullYear()}/${((_d.getMonth() + 1) < 10 ? '0' : '')}${(_d.getMonth() + 1)}/${_d.getDate() < 10 ? '0' : ''}${_d.getDate()} 
                ${_d.getHours() < 10 ? '0' : ''}${_d.getHours()}:${_d.getMinutes() < 10 ? '0' : ''}${_d.getMinutes()}
            `
        }
    }
    const LessonDateFormat2 = (timeString: string) => {
        return `
            ${1911 + parseInt(timeString.slice(0, 3))}/${(timeString.slice(3, 5))}/${(timeString.slice(5, 7))}
        `
    }

    const loadData = () => {
        ws.WebService.asyncGetActMainOtsList(bc.Class1).then((res: any) => {
            ////setCards(res.Data as CardProps[])


            console.log(res)
            const temp: (CardProps)[] = res.Data as CardProps[]

            //20230628設定過濾條件
            let to: TO = { "all": "顯示全部" }
            let PD: PDO = {}
            temp.map((item: CardProps) => {
                item.propertyCodes = [];
                if (item.jPropertys) {
                    const _ps: Properties[] = JSON.parse(item.jPropertys) as Properties[]
                    //將課程分類編號加入至propertyCodes
                    _ps.map((p: Properties) => {
                        item.propertyCodes.push(p.PropertyCode)
                        to = { ...to, [p.PropertyCode]: p.PropertyName }
                        PD[p.PropertyCode] = p.PropertyName
                    })
                }
            })
            let to2: Properties[] = []
            for (const key in to) {
                to2.push({
                    PropertyCode: key,
                    PropertyName: to[key],
                } as Properties)
            }
            setProperties(to2)
            setPropertiesDictionary(PD)
            //20230628設定過濾條件end

            bc.setCardList(temp)
        })
    }

    useEffect(() => {
        loadData();
        //法定必修
        //選修課程
        //console.log(bc.Class1)
        setTypeTitle(bc.Class1 == "A" ? "活動" : bc.Class1 == "B" ? "課程" : "")
        return
    }, [bc.Class1])

    useEffect(() => {
        //預設的Menu ID
        if (!bc.BID) {
            bc.setBID(bc.PID)
        }
        //console.log(bc.BID)
    }, [bc.PID])


    //判斷預設是不是要開啟課程卡片
    useEffect(() => {
        /*
        console.log("cardList", bc.cardList )
        console.log("ActID", bc.ActID)*/

        if (bc.cardList && bc.ActID) {
            bc.cardList.map((card: CardProps, index: number) => {
                if (card.ActID == bc.ActID) {
                    bc.setOpenCard(true)
                    setNowCards(card)
                }

            })
        }
    }, [bc.ActID, bc.cardList])
    /*
    const RegSerialFilter =  (dataString:string):number=>{
        const data:{Serial:string; Account:string}[] = JSON.parse(dataString)
        data.map(item=>{
        })
        console.log(data)
        return 0
    }
    */

    return (
        <>
            <div id="courseList">
                <select className="hibSelect" onChange={(event: React.ChangeEvent<HTMLSelectElement>) => setPCurrentCode(event.target.value)}>
                    {
                        properties.map(
                            (item: Properties, index: number) =>
                                <option key={"property_" + index} value={item.PropertyCode}>
                                    {item.PropertyName}
                                </option>
                        )
                    }
                </select>
                <div id="lessons" className="list">

                    {
                        //header

                        bc.cardList &&
                        bc.cardList.length > 0 &&
                        <div className="lessonsTemplate lessionCard list header">
                            {/*
                            <div className="actID">課號</div>
                             */}
                            <div className="actTitle">{typeTitle}ID/名稱</div>
                            <div className="actDate">{typeTitle}日期</div>
                            <div className="actTime">{typeTitle}時間</div>
                            <div className="location">{typeTitle}地點</div>
                            <div className="beginEndTime">報名期間</div>
                            <div className="reg-max">報名人數/上限人數</div>
                            <div className="accept-max">正取人數</div>
                            <div className="state">狀態</div>
                        </div>
                    }
                    {
                        bc.cardList == undefined ?
                            <div className="loading">
                                <img className="spinner" src={SpinnerSvg()} />
                            </div> :
                            bc.cardList.length == 0 ?
                                <div className="no-lession">
                                    <div className="txt">
                                        <img src={BookDot()} />
                                        此分類目前沒有{typeTitle}。
                                    </div>
                                </div> : ""
                    }
                    {
                        bc.cardList &&
                        bc.cardList.map((card: CardProps, index: number) => {
                            //過濾條件
                            //pCurrentCode會去比對卡片中的propertyCodes代號是不是有符合選擇的類別
                            let hit: boolean = false
                            if (pCurrentCode == "all") {
                                hit = true
                            } else if (card.propertyCodes.indexOf(pCurrentCode) != -1) {
                                hit = true
                            }
                            if (hit) {
                                return (
                                    <div
                                        key={"card-" + index}
                                        /*
                                        className={"lessonsTemplate lessionCard list " + (
                                            (card.regState == 1 && card.ActID == "S20230001") ? "disabled" : ""
                                        )}*/
                                        className={"lessonsTemplate lessionCard list "}
                                        onClick={() => {
                                            bc.setOpenCard(true)
                                            setNowCards(card)
                                        }}
                                    >
                                        {
                                            /*
                                            <div className="actID">
                                            </div>
                                            */
                                        }

                                        <div className="actTitle">
                                            <span className="actID">{card.ActID}</span>
                                            <span>{card.ActTitle}</span>
                                            <div className="labels">
                                                <div>
                                                    {
                                                        card.propertyCodes &&
                                                        card.propertyCodes.map((PID: string, index: number) =>
                                                            <label className="lessonLabel typeLable red" key={"typeLable_" + index}>
                                                                {propertiesDictionary[PID]}
                                                            </label>
                                                        )

                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className="actDate">
                                            <span className="mobileLabel">{typeTitle}日期</span>
                                            {card.ActDate ? card.ActDate : "無"}
                                        </div>
                                        <div className="actTime">
                                            <span className="mobileLabel">{typeTitle}時間</span>
                                            {card.ActTime ? card.ActTime : "無"}
                                        </div>
                                        <div className="location">
                                            <span className="mobileLabel">{typeTitle}地點</span>
                                            {card.Location ? card.Location : "無"}
                                        </div>
                                        <div className="beginEndTime">
                                            {/*
                                                <span className="mobileLabel">{typeTitle}期間</span>
                                            */}
                                            <span className="mobileLabel">報名期間</span>
                                            {
                                                card.BeginTime && card.EndTime ?
                                                    <div className="fromToBox">
                                                        <span className="from">{LessonDateFormat(card.BeginTime)}</span>
                                                        <span className="to">{LessonDateFormat(card.EndTime)}</span>
                                                    </div> :
                                                    "無報名時間"
                                            }
                                        </div>
                                        {/**
                                         * 
                                        <div className="regTotal">
                                            {
                                                card.RegTotal
                                            }/{
                                                card.Maximum ?
                                                    card.Maximum : "無"
                                            }
                                        </div>
                                            */}

                                        <div className="reg-max">

                                            <span className="mobileLabel">報名人數/上限人數</span>
                                            {

                                                card.ActID != "S20241052" &&
                                                <>
                                                    {
                                                        card.regState == 6 ? "--" :
                                                            card.RegTotal ? card.RegTotal : 0
                                                    }/{
                                                        card.regState == 6 ? "--" :
                                                            card.Maximum ? card.Maximum : "無"
                                                    }
                                                </>
                                            }
                                        </div>


                                        <div className="accept-max">
                                            <span className="mobileLabel">正取人數</span>
                                            {
                                                card.regState == 6 ? "--" :
                                                    card.acceptNum ? card.acceptNum : "無"
                                            }

                                            {


                                            }
                                        </div>

                                        <div className="state">
                                            <span className="mobileLabel">狀態</span>
                                            {

                                                card.regState == 7 ?
                                                    <span>
                                                        <span className="">已截止</span>/
                                                        <span className="yes">
                                                            已報名
                                                        </span>
                                                    </span> :
                                                    card.regState == 8 ?
                                                        <span>
                                                            <span className="">已截止</span> /
                                                            <span className="no">不參加</span>
                                                        </span> :
                                                        card.regState == 11 ?
                                                            <span>
                                                                <span className="">已截止</span> /
                                                                <span className="no">不參加</span>
                                                            </span> :
                                                            card.regState == 6 ?
                                                                <span className="">點選進入</span> :
                                                                card.regState == 1 ?
                                                                    <span className="yes">
                                                                        已報名
                                                                        {/*
                                                           card.acceptNum  && card.acceptNum != 0 && (card.RegTotal - card.acceptNum >0  ) &&
                                                           <>
                                                            <br/>
                                                            <span>備取{RegSerialFilter(card.RegSerial)}</span>
                                                           </>
                                                        */}
                                                                    </span> :
                                                                    card.regState == 2 ?
                                                                        <span className="no">審核中</span> :
                                                                        card.regState == 9 ?
                                                                            <span className="no">審核未通過</span> :
                                                                            card.regState == 10 ?
                                                                                <span className="no">已取消</span> :
                                                                                card.regState == 3 ?
                                                                                    <span className="no">不參加</span> :
                                                                                    card.regState == 4 ?
                                                                                        <span className="deadline">已截止</span> :
                                                                                        card.regState == 5 ?
                                                                                            <span className="full">人數已滿</span> :
                                                                                            card.regState == 0 ?
                                                                                                <span className="ready">尚未報名</span> : ""
                                            }
                                        </div>

                                    </div>
                                )
                            }
                        })
                    }
                </div>
            </div>
            <CardDetail cardData={nowCard} />
        </>
    )
}